<template>
  <div class="row">
    <div
      class="col-12 col-sm-6 col-md-4"
      v-for="avaliationItem in filteredAvaliationItems"
      :key="avaliationItem.id"
    >
      <avaliation-item-dashboard-card
        :avaliation-item="avaliationItem"
      />
    </div>

    <div v-show="avaliationItems.length" class="col-12 col-sm-6 col-md-4">
      <avaliation-result-card :avaliation="avaliation" />
    </div>
  </div>
</template>

<script>
import AvaliationItemDashboardCard from './AvaliationItemDashboardCard.vue';
import AvaliationResultCard from './avaliationResultCard.vue';
export default {
  name: 'AvaliationItemDashboard',
  components: { AvaliationItemDashboardCard, AvaliationResultCard },
  props: {
    avaliationItems: {
      type: Array,
      required: true,
    },
    avaliation: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    filteredAvaliationItems() {
      return this.avaliationItems.filter(avaliationItem => !['label', 'text'].includes(avaliationItem.strategy));
    },
  }
}
</script>
